<template>
  <main class="otp-confirmation">
    <!-- Challenge / Processing zone -->
    <section class="otp-confirmation__content">
      <h1 class="otp-confirmation__heading">
        {{ methodLabelTitle }}
      </h1>
      <p class="otp-confirmation__description">
        Мы отправили вам код подтверждения в {{ methodLabelDescription }}.
        У вас {{ attempts }} попытки.
      </p>

      <div class="otp-confirmation__input-group">
        <label for="otp-code" class="otp-confirmation__input-label">
          Код подтверждения
        </label>
        <v-text-field
          ref="otpInput"
          id="otp-code"
          :value="code"
          @input="onConfirmationCodeInput"
          @focus="onInputFocus"
          outlined
          type="number"
          solo
          hide-details
          placeholder="123456"
          class="otp-confirmation__input"
        />
      </div>

      <v-btn
        class="otp-confirmation__confirm-btn"
        depressed
        :disabled="!code || code.length !== 6"
        @click="confirmCode"
      >
        Подтвердить
      </v-btn>

      <button class="otp-confirmation__resend-btn" @click="resendCode" v-if="currentAttempt < attempts">
        Отправить код повторно
      </button>
    </section>

    <!-- Information zone -->
    <footer class="otp-confirmation__footer">
      <div class="otp-confirmation__help-btn" @click="needHelp" v-if="currentAttempt > 1">
        Попытка {{ currentAttempt }} из {{ attempts }}
      </div>
    </footer>
  </main>
</template>

<script>
import { tryGetCurrentUser } from '@/utils/usersLegacy';

export default {
  name: 'PhoneLikeConfirmationForm',
  props: {
    attempts: {
      type: Number,
      default: 3,
    },
    currentAttempt: {
      type: Number,
      default: 1,
    },
    identityType: {
      type: String,
      default: 'Phone',
    },
    code: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentUserData: null,
    }
  },
  computed: {
    methodLabelTitle() {
      const titles = {
        // WhatsApp: 'Введите код подтверждения из WhatsApp',
        TelegramPhone: 'Введите код подтверждения из Telegram',
        MaxPhone: 'Введите код подтверждения из MAX',
        Phone: 'Введите код подтверждения из SMS',
      }
      return titles[this.identityType] || titles.Phone
    },
    methodLabelDescription() {
      const maskedPhone = this.currentUserData?.contact?.replace(/^(\+7)(\d{3})(\d{3})(\d{2})(\d{2})$/, '$1 ### ###-$4-$5')
      const descriptions = {
        // WhatsApp: `WhatsApp, привязанный к номеру ${maskedPhone}`,
        TelegramPhone: `Telegram, привязанный к номеру ${maskedPhone}`,
        MaxPhone: `MAX, привязанный к номеру ${maskedPhone}`,
        Phone: `SMS, на номер ${maskedPhone || '+7...'}`,
      }
      return descriptions[this.identityType] || descriptions.Phone
    },
  },
  methods: {
    onConfirmationCodeInput(value) {
      this.$emit('input', value)
    },
    confirmCode() {
      this.$emit('confirmCode', this.code)
    },
    resendCode() {
      this.$emit('resendCode')
    },
    needHelp() {
    },
    async fetchCurrentUser() {
      this.currentUserData = await tryGetCurrentUser(this.$route.query.id || this.id, this.$route.query.uid || this.uid)
    },
    onInputFocus() {
      // Небольшая задержка, чтобы клавиатура успела появиться
      setTimeout(() => {
        const inputEl = this.$refs.otpInput.$el.querySelector('input');
        if (inputEl) {
          inputEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 300);
    },
  },
  async mounted() {
    await this.fetchCurrentUser()
  }
}
</script>

<style lang="scss">
.otp-confirmation {
  display: grid;
  grid-template-rows: auto 1fr auto;
  background: #fafafa;

  &__header {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    padding: 0 24px;
    background-color: #008f2e;
    color: #fff;
    height: 64px;

    & .otp-confirmation__logo {
      height: 32px;
      margin-right: 8px;
    }
    & .otp-confirmation__title {
      font-size: 1.25rem;
      font-weight: bold;
    }
    & .otp-confirmation__identifier {
      justify-self: center;
      font-size: 0.875rem;
    }
    & .otp-confirmation__menu-btn {
      justify-self: end;
      color: #fff;
    }
  }

  &__content {
    display: grid;
    grid-gap: 16px;
    justify-items: center;
    align-content: start;
    padding: 40px 24px;
  }

  &__heading {
    font-size: 1.5rem;
    margin: 0;
    text-align: center;
  }
  &__description {
    font-size: 1rem;
    color: #555;
    text-align: center;
    max-width: 392px;
  }

  &__input-group {
    display: grid;
    grid-gap: 8px;
    width: 100%;
    max-width: 320px;
    .v-text-field__slot {
      /* Chrome, Safari, Edge, Opera */
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      /* Firefox */
      input[type=number] {
        -moz-appearance: textfield;
      }
    }
  }
  &__input-label {
    font-size: 0.875rem;
    color: #777;
    text-align: center;
  }
  &__input {
    width: 100%;
    font-size: 40px;
    // min-width: 250px;
    input {
      text-align: center;
    }
  }

  &__confirm-btn {
    width: 100%;
    max-width: 320px;
    height: 42px !important;
    background-color: #008f2e !important;
    color: #fff !important;
    // text-transform: none;
  }

  &__resend-btn {
    background: none;
    border: none;
    color: #008f2e;
    font-size: 0.875rem;
    cursor: pointer;
    text-decoration: underline;
    margin-top: 8px;
  }

  &__footer {
    display: flex;
    justify-content: center;
    padding: 16px;

    & .otp-confirmation__help-btn {
      background: none;
      border: none;
      color: #555;
      font-size: 0.875rem;
      // cursor: pointer;
      // text-decoration: underline;
    }
  }
}
</style>